import React from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';

import Email from 'components/auth/ManageYourBooking/Email';
import BookingID from 'components/auth/ManageYourBooking/BookingID';
import LostBookingID from 'components/auth/ManageYourBooking/LostBookingId';

import styles from './index.module.css';

export enum Tab {
  haveAnAccount = 'I have an account',
  haveBookingId = 'I have the booking ID',
  lostBookingId = 'I lost my booking ID',
}

type LocationState = {
  tab?: Tab;
};

const ManageYourBooking: React.FC = () => {
  const { t } = useTranslation();
  const locationState = useLocation<LocationState>();

  const [currentTab, setCurrentTab] = React.useState<Tab>(locationState.state?.tab ?? Tab.haveAnAccount);

  return (
    <div className={styles.header}>
      <div className={`container ${styles.container}`}>
        <h4>{t('views:manageYourBooking.header')}</h4>

        <div className={styles.body}>
          <div className="row text-center ml-0 mr-0">
            {Object.entries(Tab).map(([name, value]) => (
              <div
                key={value}
                className={`col-md-4 ${currentTab === value ? styles.active : styles.inactive}`}
                onClick={() => setCurrentTab(value)}
              >
                <h5>
                  <span>{t(`views:manageYourBooking.tabs.${name}`)}</span>
                </h5>
              </div>
            ))}
          </div>

          <div className={`row pt-5 ml-0 mr-0 ${styles.bodyContent}`}>
            {currentTab === Tab.haveAnAccount && <Email />}
            {currentTab === Tab.haveBookingId && <BookingID />}
            {currentTab === Tab.lostBookingId && <LostBookingID />}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ManageYourBooking;
